export default __webpack_public_path__ + "static/media/heroDesktop.efcb304d.webp";